export default "__VITE_ASSET__b7580e0e__"